<template>
  <div>
    <AdminSlidersAdd
      :is_editing="true"
      ref="edit_slider_form_ref"
      :is_loading="is_loading"
      @on-success-edit="on_success_edit"
      @on-show-loader="$emit('on-show-loader')"
      @on-hide-loader="$emit('on-hide-loader')"
    >
    </AdminSlidersAdd>
  </div>
</template>

<script>
import AdminSlidersAdd from "./AdminSlidersAdd";
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
export default {
  name: "AdminSlidersEdit",
  components: {
    AdminSlidersAdd,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      slider: Utils.get_default_slider(),
      slider_id: 0,
    };
  },
  methods: {
    load_slider() {
      this.$emit("on-show-loader");
      ServerClient.Sliders.get_slider(
        {
          id: this.slider_id,
        },
        (res) => {
          this.$emit("on-hide-loader");
          console.log("slider to be edited ", res);
          this.slider = res;
          this.$refs.edit_slider_form_ref.init_editing_form(this.slider);
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log(
            "Errors while loading slider details on admin edit slider ",
            errors
          );
        }
      );
    },
    on_success_edit() {
      this.load_slider();
    },
  },
  mounted() {
    this.slider_id = this.$route.params.id;
    this.$emit("set-page-attributes", {
      title: "Edit Category",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Sliders",
          disabled: false,
          href: "/admin/sliders",
        },
        {
          text: "List",
          disabled: false,
          href: "/admin/sliders/list",
        },
        {
          text: "Edit",
          disabled: true,
          href: "/admin/sliders/list/edit/" + this.slider_id,
        },
      ],
    });
    this.load_slider();
  },
};
</script>